module.exports = __webpack_public_path__ + "static/media/instruction_3.90420c74.svg";